import styled from "styled-components";

const CustomDivScroll = styled.div`
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-button {
    width: 0px;
    height: 0px;
  }
  ::-webkit-scrollbar-thumb {
    background: #0073ab;
    border-radius: 20px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #0073ab;
  }
  ::-webkit-scrollbar-thumb:active {
    background: #0073ab;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 50px;
  }
  ::-webkit-scrollbar-track:hover {
    background: transparent;
  }
  ::-webkit-scrollbar-track:active {
    background: transparent;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;

export const Container = styled(CustomDivScroll)`
  overflow-y: auto;
  padding: 0  15px;
`;

export const SectionTitle = styled.p`
  font-size: 18px;
  font-weight: bolder;
  color: #1a1a1a;
`;

export const InputLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
`;

export const LabelText = styled.p`
  font-size: 16px;
  color: #1a1a1a;
  margin-bottom: 8px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 30px;
`;

export const ActionIcon = styled.img`
  width: 20px;
  height: 20px;
  pointer-events: cursor;
  overflow-x: hidden;
  transform: rotate(180deg);
  transition: all 1s;
  cursor: pointer;
  margin-right: 15px;
`;

export const ActionIconRight = styled.img`
  width: 20px;
  height: 20px;
  pointer-events: cursor;
  overflow-x: hidden;
  transition: all 1s;
  cursor: pointer;
`;
